import { getFileExtension, isImageFile } from 'v5/platform/files/fileUtils';

/** A file stored through `UploadService`, as upload fields hold it. */
export type UploadedMedia = {
  fileId: string;
  accessUrl: string;
  name: string;
  mimeType?: string;
  /** Local blob URL of a just-uploaded image, shown instead of fetching it. */
  previewUrl?: string;
};

export type MediaKind = 'image' | 'video' | 'pdf' | 'link' | 'other';

/** What a file is, from its MIME type or, without one, its name. */
export function mediaKindOf(file: {
  name: string;
  mimeType?: string;
}): MediaKind {
  const type = file.mimeType ?? '';
  if (type.startsWith('image/') || (type === '' && isImageFile(file.name))) {
    return 'image';
  }
  if (type.startsWith('video/')) return 'video';
  if (type === 'text/uri-list') return 'link';
  if (type === 'application/pdf' || getFileExtension(file.name) === 'pdf') {
    return 'pdf';
  }
  return 'other';
}

/** The image to show for a file: its local copy while there is one. */
export function mediaImageSrc(media: UploadedMedia): string {
  return media.previewUrl ?? media.accessUrl;
}
